export const NEWS_LETTER_FEATURE_KEY = 'NEWS LETTER';

export interface State{
    loaded:boolean;
    error?:string | null;
    data: number|null;
}